// Web mock for @react-native-async-storage/async-storage
const AsyncStorage = {
  async getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },

  async setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      throw error;
    }
  },

  async removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      throw error;
    }
  },

  async mergeItem(key, value) {
    try {
      const existingValue = await this.getItem(key);
      if (existingValue) {
        const existingObject = JSON.parse(existingValue);
        const newObject = JSON.parse(value);
        const mergedObject = { ...existingObject, ...newObject };
        await this.setItem(key, JSON.stringify(mergedObject));
      } else {
        await this.setItem(key, value);
      }
    } catch (error) {
      throw error;
    }
  },

  async clear() {
    try {
      localStorage.clear();
    } catch (error) {
      throw error;
    }
  },

  async getAllKeys() {
    try {
      const keys = [];
      for (let i = 0; i < localStorage.length; i++) {
        keys.push(localStorage.key(i));
      }
      return keys.filter(key => key !== null);
    } catch (error) {
      return [];
    }
  },

  async multiGet(keys) {
    try {
      const result = [];
      for (const key of keys) {
        const value = await this.getItem(key);
        result.push([key, value]);
      }
      return result;
    } catch (error) {
      throw error;
    }
  },

  async multiSet(keyValuePairs) {
    try {
      for (const [key, value] of keyValuePairs) {
        await this.setItem(key, value);
      }
    } catch (error) {
      throw error;
    }
  },

  async multiRemove(keys) {
    try {
      for (const key of keys) {
        await this.removeItem(key);
      }
    } catch (error) {
      throw error;
    }
  },

  async multiMerge(keyValuePairs) {
    try {
      for (const [key, value] of keyValuePairs) {
        await this.mergeItem(key, value);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default AsyncStorage;
